const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : UserController
 */

function UserController(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

UserController.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_UserController = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const UserController_null_default = new StateJS.State('default', this._statemachine);
  _initial_UserController.to(UserController_null_default);
  UserController_null_default.on(Event.Touch).when((touch) => touch.port === 'keepAliveButton' && touch.type === 'touch').effect((touch) => {
    this.keepAlive();
  });
  UserController_null_default.on(Event.Touch).when((touch) => touch.port === 'stopButton' && touch.type === 'touch').effect((touch) => {
    this.stop();
  });
  UserController_null_default.on(Event.Touch).when((touch) => touch.port === 'playButton' && touch.type === 'touch').effect((touch) => {
    this.play();
  });
};
UserController.prototype.play = function () {
  this.bus.emit('videoControl', new Event.Play_VideoControllerMsg(this.name, 'videoControl'));
};

UserController.prototype.stop = function () {
  this.bus.emit('videoControl', new Event.Stop_VideoControllerMsg(this.name, 'videoControl'));
};

UserController.prototype.keepAlive = function () {
  this.bus.emit('keepalive', new Event.KeepAlive_KeepAliveControllerMsg(this.name, 'keepalive'));
};

UserController.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

UserController.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

UserController.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

UserController.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

UserController.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += '';
  return result;
};

module.exports = UserController;
